export default __webpack_public_path__ + "static/media/JEROME MICO JAROPOJOP.f782d357.pdf";